module.exports = __webpack_public_path__ + "img/air.9ea8abe5.png";